module.exports = __webpack_public_path__ + "img/landings.1c1497be.png";